<div class="modal fade" id="modalProduct" tabindex="-1" aria-labelledby="modalProductLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <button type="btn btn-secondary" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p class="{{messageType}}" id="modalProductLabel">{{message}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
            </div>
        </div>
    </div>
</div>

<div class="housing-page">
    <div class="housing-header">
        <div>
            
            <h1>Liste de vos produits immobiliers</h1>
            <p>Consultez et gérez les produits déjà ajoutés.</p>
            
        </div>
    </div>

    <div class="housing-card">
        <div class="view-switch">
           
            <button class="btn btn-primary" type="button" (click)="goTList()">Lister les
                produits</button>
            
        </div>

        @if ( !preview) {
        <form [formGroup]="productForm" (ngSubmit)="submitProduct()" class="housing-form">
            <input type="hidden" formControlName="promoterId" />
            <input type="hidden" formControlName="id" />
            <div class="grid-row">
                <div class="field-group">
                    <label for="name">Nom du produit</label>
                    <input id="name" type="text" formControlName="name" placeholder="Ex: Villa haute standingr" />
                    <div class="error">
                        @if (submitted && f['name'].invalid) {
                        <span>Le nom doit contenir au moins 5 caractères.</span>
                        }
                    </div>
                </div>

                <div class="field-group">
                    <label for="type">Type de bien</label>
                    <select id="type" formControlName="type">
                        <option value="">Sélectionnez</option>
                        <option value="Appartement">Appartement</option>
                        <option value="Villa">Villa</option>
                        <option value="Terrain">Terrain</option>
                        <option value="Maison">Maison</option>
                        <option value="Duplex">Duplex</option>
                    </select>
                    <div class="error">
                        @if (submitted && f['type'].invalid) {
                        <span>Le type du produit est requis.</span>
                        }
                    </div>
                </div>
            </div>

            <div class="grid-row">

                <div class="field-group">
                    <label for="durationYears">Durée (années)</label>
                    <input id="durationYears" type="number" formControlName="durationYears" min="1" max="60" />
                    <div class="error">
                        @if (submitted && f['durationYears'].invalid) {
                        <span>La durée doit être comprise entre 1 et 60 ans.</span>
                        }
                    </div>
                </div>

                <div class="field-group">
                    <label for="price">Prix (FCFA)</label>
                    <input id="price" type="number" formControlName="price" placeholder="Montant en chiffres" />
                    <div class="error">
                        @if (submitted && f['price'].invalid) {
                        <span>Le prix doit être un nombre valide.</span>
                        }
                    </div>
                </div>
            </div>
           
            <div class="grid-row">
                <div class="field-group">
                    <label for="openingFees">Frais de dossier</label>
                    <input id="openingFees" type="number" formControlName="openingFees" min="0" />
                </div>
                <div class="field-group">
                    <label for="insuranceAmount">Le cout de l'assurance</label>
                    <input id="insuranceAmount" type="number" formControlName="insuranceAmount" min="0" />
                </div>
            </div>
              <div class="field-group">
                    <select class="form-select" formControlName="country" id="countryProduct">
                        <option value=""> Selectionner le pays du produit</option>
                        @for(country of countries;track $index){
                            <option value="{{country.isoCode2}}">{{country.name}}</option>

                        }

                    </select>
                   
                </div>
            <div class="grid-row">
                <div class="field-group">
                    <label for="zone">Zone géographique</label>
                    <input id="zone" type="text" formControlName="zone" placeholder="Bambilor, thies" />
                    <div class="error">
                        @if (submitted && f['zone'].invalid) {
                        <span>La zone géographique est requise.</span>
                        }
                    </div>
                </div>

                <div class="field-group">
                    <label for="superficie">Surface (m²)</label>
                    <input id="superficie" type="text" formControlName="superficie" placeholder="Superficie en m²" />
                    <div class="error">
                        @if (submitted && f['superficie'].invalid) {
                        <span>La surface doit etre renseigner.</span>
                        }
                    </div>
                </div>
            </div>

            <div class="field-group">
                <div class="field-group full-width">
                    <label for="specifications">Spécifications</label>
                    <textarea id="specifications" formControlName="specifications" rows="5"
                        placeholder="Décrivez les spécifications du produit"></textarea>
                    <div class="error">
                        @if (submitted && f['specifications'].invalid) {
                        <span>La description doit contenir au moins 20 caractères.</span>
                        }
                    </div>
                </div>
            </div>
            <div class="form-actions">
                <button class="btn btn-primary" type="submit">Suivant</button>
                <button class="btn btn-secondary" type="button" (click)="resetForm()">Réinitialiser</button>
            </div>

        </form>

        }
        @if ( preview) {
        <div class="housing-preview">
            <h2>Détails du produit</h2>
            <p><strong>Nom :</strong> {{preview.name}}</p>
            <p><strong>Type :</strong> {{preview.type}}</p>
            <p><strong>Durée :</strong> {{preview.durationYears}}</p>
            <p><strong>Frais dossier :</strong> {{preview.openingFees}}</p>
            <p><strong>Montant assurance :</strong> {{preview.insuranceAmount}}</p>
            
            <p><strong>Zone géographique :</strong> {{preview.zone}}</p>
            <p><strong>Prix :</strong> {{preview.price}} €</p>
            <p><strong>Superficie :</strong> {{preview.superficie}} m²</p>
            <p><strong>Duurée : {{preview.durationYears}}</strong></p>
            <p><strong>Spécifications :</strong> {{preview.specifications}}</p>
            <div class="form-actions">
                <button class="btn btn-primary" type="button" (click)="addOrEditProduct()">Enregistrer le
                    produit</button>
                <button class="btn btn-secondary" type="button" (click)="displaayForm()">Modifier</button>
            </div>
        </div>
        }

    </div>
</div>